import React from 'react';
import Services from '../components/Services';
import QuoteBand from '../components/QuoteBand';

export default function ServicesPage({ selectedService = '' }) {
  return (
    <section className="page-section">
      <div className="page-hero">
        <span className="page-hero-label">Services</span>
        <h1>Explore Our <span>Support Services</span></h1>
        <p>
          From fresher hiring and lateral placement to certification, interview, internship, and training support,
          our services are designed to help you move forward with clarity.
        </p>
      </div>
      <Services selectedService={selectedService} />
      <QuoteBand />
    </section>
  );
}
